import {useMutation} from '@apollo/react-hooks';
import gql from 'graphql-tag';
import {Role} from '../../../graphql/auth';
import {updateCacheByType} from '../../../graphql/GraphQlProvider';
import {gqlRole} from '../getRole.api';

interface CreateRoleVars {
    data: {
        name?: string
        ident?: string
        description?: string
        active?: boolean
        level?: number
        permissions?: {
            connect: number[]
        }
    }
}

interface CreateRoleData {
    createRole: Role
}

export const CREATE_ROLE_MUTATION = gql`
    mutation createRole($data: CreateRoleInput!) {
        createRole(data: $data) {
            ${gqlRole}
        }
    }
`;

export const createRole = () => useMutation<CreateRoleData, CreateRoleVars>(
    CREATE_ROLE_MUTATION,
    {
        update: updateCacheByType('Role'),
    }
);

export default createRole;